const Clipboard = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="20"
      viewBox="0 0 15 20"
    >
      <path
        data-name="Icon awesome-clipboard-list"
        d="M13.125 2.5H10a2.5 2.5 0 0 0-5 0H1.875A1.875 1.875 0 0 0 0 4.375v13.75A1.875 1.875 0 0 0 1.875 20h11.25A1.875 1.875 0 0 0 15 18.125V4.375A1.875 1.875 0 0 0 13.125 2.5zM3.75 16.563a.938.938 0 1 1 .938-.937.935.935 0 0 1-.938.937zm0-3.75a.938.938 0 1 1 .938-.937.935.935 0 0 1-.938.937zm0-3.75a.938.938 0 1 1 .938-.937.935.935 0 0 1-.938.937zm3.75-7.5a.938.938 0 1 1-.937.938.935.935 0 0 1 .937-.938zm5 14.375a.313.313 0 0 1-.312.313H6.563a.313.313 0 0 1-.312-.312v-.625A.313.313 0 0 1 6.563 15h5.625a.313.313 0 0 1 .313.313zm0-3.75a.313.313 0 0 1-.312.313H6.563a.313.313 0 0 1-.312-.312v-.625a.313.313 0 0 1 .313-.312h5.625a.313.313 0 0 1 .313.313zm0-3.75a.313.313 0 0 1-.312.313H6.563a.313.313 0 0 1-.312-.312v-.626a.313.313 0 0 1 .312-.313h5.625a.313.313 0 0 1 .313.313z"
      />
    </svg>
  );
};

export default Clipboard;
